import { useEffect } from 'react';
import useInternetConnection from 'shared/model/useInternetConnection';
import Style from './style';

const ConnectionStatus = () => {
    const { isOnline, isOffline, resetOfflineStatus , wasOffline } = useInternetConnection();


const handleResetOfflineStatus = () => {
    setTimeout(() => {
        resetOfflineStatus();
    }, 3000);
}

    useEffect(() => {
        if (wasOffline && isOnline) {
            handleResetOfflineStatus()
        }
    }, [wasOffline, isOnline]);

    if (isOnline && !wasOffline) {
        return null;
    }
    return (
        <Style.Container $isOnline={isOnline} $wasOffline={wasOffline}>
            <Style.Icon>
                {isOffline ? '🚫' : '✅'}
            </Style.Icon>
            <Style.Message>
                {isOffline 
                    ? 'Internet connection lost. Please check your network.'
                    : 'Internet connection restored!'
                }
            </Style.Message>
        </Style.Container>
    );
};

export default ConnectionStatus;
